import { windowType } from '@/constants/Category';
import { WinContext } from '@/context/WindowFramProvier';
import { myFallback } from '@/libs/constant/Constant';
import { Suspense, useContext } from 'react';
import { Outlet } from 'react-router-dom';

export default function WindowLayer() {
  const { app } = useContext(WinContext);

  return (
    <>
      {app === windowType ? (
        <div className="h-screen">
          <div className="h-[40px] bg-slate-600 flex items-center justify-start shadow">
            <h2 className="text-white pl-2 text-lg">VAPL - ERP System</h2>
          </div>
          <div className="overflow-y-auto overflow-x-hidden h-[calc(100vh-40px)]">
            <Suspense fallback={myFallback}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      ) : (
        <div className="overflow-y-auto overflow-x-hidden h-screen">
          <Suspense fallback={myFallback}>
            <Outlet />
          </Suspense>
        </div>
      )}
    </>
  );
}
